var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.955 109.91C85.3057 109.91 109.91 85.3057 109.91 54.955C109.91 24.6042 85.3057 0 54.955 0C24.6042 0 0 24.6042 0 54.955C0 85.3057 24.6042 109.91 54.955 109.91Z",
    fill: "url(#paint0_linear_2457_182)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9552 98.5954C79.0573 98.5954 98.5959 79.0568 98.5959 54.9547C98.5959 30.8526 79.0573 11.314 54.9552 11.314C30.8531 11.314 11.3145 30.8526 11.3145 54.9547C11.3145 79.0568 30.8531 98.5954 54.9552 98.5954Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 0.432432
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6406 43.6406L66.2691 66.2691M66.2691 43.6406L43.6406 66.2691",
    stroke: "white",
    strokeWidth: 1.98198,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2457_182",
    x1: 0,
    y1: 0,
    x2: 109.91,
    y2: 109.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B24E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailCircle);
export default __webpack_public_path__ + "static/media/fail-circle.44ad83007854947e2aa5189dea79dc49.svg";
export { ForwardRef as ReactComponent };